import { DAY_MS } from "@/utils/datetime";

// Policy 카탈로그의 등록일 기간 퀵 필터 어휘. 세션 목록의 학습 시작일 프리셋
// (sessionStartedWithin.ts)과 같은 네 단어다. 기간은 현재 시각 기준으로 움직인다. 달력 경계가
// 아니라 `now - windowMs` 이후에 등록된 Policy 만 남긴다. 등록일 열의 상대 시간 표시와 같은 기준이다.
// URL 값(week·2weeks·month)은 영문 키를 유지한다. 그래서 공유한 링크가 계속 동작한다.
// 기간을 바꾸면 스코프 카탈로그를 클라이언트에서 다시 거르므로 왕복이 없다(rules.md §7). 카탈로그
// API 에 created_at 범위(`from`/`to`)가 있지만 쓰지 않는다. 움직이는 now 를 서버로 보내면 토글마다
// 왕복이 생기고 api 캐시 서명이 매번 달라진다.

export const POLICY_REGISTERED_WITHIN_OPTIONS = [
  { value: "all", label: "전체", windowMs: null },
  { value: "week", label: "최근 1주", windowMs: 7 * DAY_MS },
  { value: "2weeks", label: "최근 2주", windowMs: 14 * DAY_MS },
  { value: "month", label: "최근 한 달", windowMs: 30 * DAY_MS },
] as const;

export type PolicyRegisteredWithin = (typeof POLICY_REGISTERED_WITHIN_OPTIONS)[number]["value"];

// 기본값이자 "필터 없음" sentinel(facet 드롭다운의 neutralValue). URL 에서는 키를 빼서 표현한다.
export const ALL_POLICY_REGISTERED_WITHIN: PolicyRegisteredWithin = "all";

export function policyRegisteredWithinLabel(value: PolicyRegisteredWithin): string {
  return POLICY_REGISTERED_WITHIN_OPTIONS.find((option) => option.value === value)?.label ?? value;
}

// URL 과 컨트롤 값은 외부 입력이다. 정확한 어휘만 받는다(대소문자·공백 변형은 거절한다).
export function isPolicyRegisteredWithin(value: string | null): value is PolicyRegisteredWithin {
  return POLICY_REGISTERED_WITHIN_OPTIONS.some((option) => option.value === value);
}

// 기간의 시작 instant(ms). `all`(windowMs 가 없는 유일한 옵션)은 null 이다. 필터를 적용하지 않는다는 뜻이다.
export function registeredWithinCutoffMs(
  value: PolicyRegisteredWithin,
  nowMs: number,
): number | null {
  const windowMs =
    POLICY_REGISTERED_WITHIN_OPTIONS.find((option) => option.value === value)?.windowMs ?? null;
  return windowMs === null ? null : nowMs - windowMs;
}
